import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import './AdminLayout.css';

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/admin/login');
  }

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <i className="fas fa-shield-alt"></i>
          <span>VacationSystem</span>
          <small>Panel Admin</small>
        </div>

        <nav className="admin-nav">
          <NavLink to="/admin/empresas" className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}>
            <i className="fas fa-building"></i>
            Empresas
          </NavLink>
          <NavLink to="/admin/planes" className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}>
            <i className="fas fa-tags"></i>
            Planes
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            <i className="fas fa-user-shield"></i>
            <span>{admin?.nombreCompleto ?? 'Super Admin'}</span>
          </div>
          <button className="admin-logout-btn" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i>
            Salir
          </button>
        </div>
      </aside>

      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
